/* eslint-disable camelcase */
import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { useReportError } from '~/hooks/useReportError';
function updateRequest(params) {
    const { offline, inOffice, id, glucoseSensorReview, didTalk, timeSpent, activityDate, followUpDate, supervisingProvider, programType } = params;
    return axios.post(`/api/report/save/${id}`, {
        offline,
        in_office: inOffice,
        glucose_sensor_review: glucoseSensorReview,
        reviewed: true,
        did_talk: didTalk,
        time_spent: timeSpent,
        activity_date: activityDate,
        supervising_provider: supervisingProvider,
        follow_up: followUpDate,
        program_type: programType
    });
}
export function usePatientReportMutation() {
    const reportError = useReportError();
    const queryClient = useQueryClient();
    return useMutation(updateRequest, {
        onSuccess: () => {
            toast.success('Changes saved successfully.');
        },
        onError: (err) => {
            reportError('Error saving patients report', err);
            toast.error('We could’t save your changes. Please try again.');
        },
        onSettled: (data, error, variables) => {
            queryClient.invalidateQueries(['patient_report', variables.id]);
        },
    });
}
